module.exports = __webpack_public_path__ + "img/012.7c3cfc14.jpg";